/* Hydrate below-fold section controls near the viewport, without changing shared components. */
(() => {
  'use strict';
  const entry = document.currentScript;
  const selector = 'gno-dialogs,gno-reviews,gno-results,gno-timeline,gno-marquee';
  let pending;
  let observer;
  const load = () => {
    if (pending) return pending;
    observer?.disconnect();
    pending = new Promise((resolve, reject) => {
      const script = document.createElement('script');
      script.src = entry.dataset.sectionsSrc;
      script.onload = resolve;
      script.onerror = () => { pending = null; reject(new Error('Section controls could not load')); };
      document.head.append(script);
    });
    return pending;
  };
  const start = () => load().catch(() => {});
  if ('IntersectionObserver' in window && !window.Shopify?.designMode) {
    observer = new IntersectionObserver(entries => {
      if (entries.some(entry => entry.isIntersecting)) start();
    }, { rootMargin: '1000px' });
    document.querySelectorAll(selector).forEach(section => observer.observe(section));
  } else start();
  // Keyboard focus and rapid jumps must not arrive at uninitialized controls.
  ['pointerover', 'focusin', 'pointerdown'].forEach(type => {
    document.addEventListener(type, event => {
      if (event.target.closest(selector)) start();
    }, { passive: true });
  });
  document.addEventListener('click', event => {
    const control = event.target.closest('[data-gno-dialog-open],[data-gno-filter-toggle],[data-gno-filter],[data-gno-more],[data-gno-expand]');
    if (!control || customElements.get('gno-dialogs') || !control.closest(selector)) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    load().then(() => { if (control.isConnected) control.click(); }).catch(() => {});
  }, { capture: true });
  document.addEventListener('shopify:section:load', start);
})();
